module.exports = __webpack_public_path__ + "static/img/16.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/16.png
// module id = a34u
// module chunks = 0